const translation = {
  // Nav
  nav_home: "Home",
  nav_shop: "Shop",
  nav_custom: "Custom Gift Box",
  nav_occasions: "Occasions",
  nav_about: "About",
  nav_contact: "Contact",
  nav_blog: "Blog",
  nav_cart: "Cart",
  nav_tagline: "Premium Gift Boutique · Douala, Cameroon",

  // Hero
  hero_headline: "Gifts That Create",
  hero_headline2: "Lasting Memories",
  hero_subtitle: "Flowers, candles, books, gourmet treats, and personalized gift boxes for every special occasion.",
  hero_btn_shop: "Shop Now",
  hero_btn_custom: "Customize a Gift Box",
  hero_btn_contact: "Contact Us",

  // Categories
  cat_title: "Our Collections",
  cat_subtitle: "Thoughtfully curated gifts for every moment",
  cat_flowers: "Fresh Flowers",
  cat_candles: "Scented Candles",
  cat_books: "Books & Journals",
  cat_jellies: "Homemade Jellies",
  cat_spices: "Gourmet Spices",
  cat_giftboxes: "Gift Boxes",
  cat_corporate: "Corporate Gifts",
  cat_seasonal: "Seasonal Gifts",
  cat_explore: "Explore",

  // Why Choose
  why_title: "Why Choose Creative Hub",
  why_subtitle: "We craft experiences, not just gifts",
  why_quality: "Premium Quality",
  why_quality_desc: "Every item is hand-selected for its beauty, quality, and emotional impact.",
  why_packaging: "Elegant Packaging",
  why_packaging_desc: "Luxurious wrapping and presentation that makes every gift unforgettable.",
  why_personalized: "Personalized Gifts",
  why_personalized_desc: "Custom messages, names, and curated selections tailored just for you.",
  why_delivery: "Fast Delivery",
  why_delivery_desc: "Reliable and timely delivery across Douala and Cameroon.",
  why_corporate: "Corporate Solutions",
  why_corporate_desc: "Bulk orders and branded gift packages for businesses and events.",

  // Bestsellers
  best_title: "Best Sellers",
  best_subtitle: "Our most loved gifts, chosen by our customers",
  best_add: "Add to Cart",
  best_whatsapp: "Order via WhatsApp",
  best_wishlist: "Add to Wishlist",

  // Custom Box
  custom_title: "Build Your Dream Gift Box",
  custom_subtitle: "Create a one-of-a-kind personalized hamper",
  custom_step1: "Choose Products",
  custom_step2: "Select Packaging",
  custom_step3: "Add a Message",
  custom_step4: "Request a Quote",
  custom_cta: "Start Customizing",

  // Testimonials
  testi_title: "What Our Customers Say",
  testi_subtitle: "Real stories from people who gifted with love",

  // CTA
  cta_title: "Make Every Occasion Special",
  cta_subtitle: "with Creative Hub",
  cta_desc: "From birthdays to corporate events, we have the perfect gift for every moment.",
  cta_btn: "Shop Now",
  cta_whatsapp: "Chat on WhatsApp",

  // Shop
  shop_title: "Our Gift Shop",
  shop_subtitle: "Discover our full collection of premium gifts",
  shop_filter_all: "All",
  shop_search: "Search gifts...",
  shop_sort: "Sort by",
  shop_sort_popular: "Most Popular",
  shop_sort_price_asc: "Price: Low to High",
  shop_sort_price_desc: "Price: High to Low",
  shop_sort_newest: "Newest",
  shop_add_cart: "Add to Cart",
  shop_whatsapp: "WhatsApp Order",
  shop_no_results: "No products found",

  // Custom Gift Box Page
  cgb_title: "Custom Gift Box",
  cgb_subtitle: "Design a personalized gift experience",
  cgb_products_title: "1. Choose Your Products",
  cgb_packaging_title: "2. Select Packaging",
  cgb_message_title: "3. Add a Personal Message",
  cgb_message_placeholder: "Write your heartfelt message here...",
  cgb_name_label: "Your Name",
  cgb_email_label: "Your Email",
  cgb_phone_label: "Phone / WhatsApp",
  cgb_submit: "Request a Quote",
  cgb_whatsapp: "Order via WhatsApp",
  cgb_selected: "Selected",
  cgb_packaging_classic: "Classic Elegance",
  cgb_packaging_luxury: "Luxury Gold",
  cgb_packaging_romantic: "Romantic Rose",
  cgb_packaging_corporate: "Corporate Premium",

  // Occasions
  occ_title: "Gifts for Every Occasion",
  occ_subtitle: "Find the perfect gift for every special moment",
  occ_birthdays: "Birthdays",
  occ_weddings: "Weddings",
  occ_anniversaries: "Anniversaries",
  occ_valentine: "Valentine's Day",
  occ_mothers: "Mother's Day",
  occ_corporate: "Corporate Events",
  occ_christmas: "Christmas",
  occ_shop_now: "Shop This Collection",

  // About
  about_title: "About Creative Hub",
  about_subtitle: "A premium gifting boutique in the heart of Douala",
  about_story_title: "Our Story",
  about_story: "Creative Hub was born from a passion for meaningful gifting. Located in Akwa, Douala, we believe every gift should tell a story — one of love, appreciation, and celebration. We hand-select every product in our collection to ensure it meets our standards of beauty, quality, and emotional resonance.",
  about_mission_title: "Our Mission",
  about_mission: "To help every customer express their deepest emotions through beautifully curated, personalized gifts that create lasting memories.",
  about_values_title: "Our Values",
  about_val1: "Elegance",
  about_val2: "Authenticity",
  about_val3: "Creativity",
  about_val4: "Care",
  about_team_title: "Meet Our Team",

  // Contact
  contact_title: "Get in Touch",
  contact_subtitle: "We'd love to hear from you",
  contact_name: "Your Name",
  contact_email: "Your Email",
  contact_phone: "Phone / WhatsApp",
  contact_subject: "Subject",
  contact_message: "Your Message",
  contact_send: "Send Message",
  contact_whatsapp: "Chat on WhatsApp",
  contact_email_us: "Email Us",
  contact_location: "Our Location",
  contact_hours: "Business Hours",
  contact_hours_val: "Mon – Sat: 8:00 AM – 7:00 PM",
  contact_address: "1401 Melrose Place, Akwa, Douala, Cameroon",
  contact_phone_val: "+237 678 012 159",
  contact_email_val: "creativehub@gmail.com",

  // Blog
  blog_title: "Gift Ideas & Inspiration",
  blog_subtitle: "Tips, trends, and stories from the world of gifting",
  blog_read_more: "Read More",
  blog_min_read: "min read",

  // Footer
  footer_tagline: "Premium gift boutique in Douala, Cameroon. Crafting memories one gift at a time.",
  footer_links: "Quick Links",
  footer_contact: "Contact",
  footer_newsletter: "Newsletter",
  footer_newsletter_desc: "Subscribe for gift ideas and exclusive offers.",
  footer_newsletter_placeholder: "Your email address",
  footer_newsletter_btn: "Subscribe",
  footer_rights: "© 2026 Creative Hub. All rights reserved.",
  footer_privacy: "Privacy Policy",
  footer_terms: "Terms of Service",

  // Cart
  cart_title: "Your Cart",
  cart_empty: "Your cart is empty",
  cart_total: "Total",
  cart_checkout: "Checkout via WhatsApp",
  cart_remove: "Remove",
  cart_continue: "Continue Shopping",

  // Common
  common_xaf: "XAF",
  common_loading: "Loading...",
  common_close: "Close",
  common_back: "Back",
  common_view_all: "View All",
  common_new: "New",
  common_sale: "Sale",
  common_popular: "Popular",
};

export default translation;